import type {
	ClientPropertyItemResponseDTO,
	PortfolioListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { portfolioCategoryOf } from "web_myplann/Portfolio/Helpers/portfolioCategoryMapping";
import {
	type CategoryItem,
	PORTFOLIO_CATEGORY_ORDER,
	type PortfolioCategoryId,
	PortfolioCategoryIds,
} from "web_myplann/Portfolio/Types/portfolioCategory";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

export const bucketPortfolioItems = (
	portfolioItems: PortfolioListItemResponseDTO[],
	propertyItems: ClientPropertyItemResponseDTO[],
): Record<PortfolioCategoryId, CategoryItem[]> => {
	const emptyBuckets = Object.fromEntries(
		PORTFOLIO_CATEGORY_ORDER.map((id) => [id, [] as CategoryItem[]]),
	) as Record<PortfolioCategoryId, CategoryItem[]>;

	const buckets = portfolioItems.reduce((acc, data) => {
		acc[portfolioCategoryOf(data.domain)].push({
			kind: PortfolioItemKind.Portfolio,
			data,
		});
		return acc;
	}, emptyBuckets);

	buckets[PortfolioCategoryIds.property].push(
		...propertyItems.map(
			(data): CategoryItem => ({ kind: PortfolioItemKind.Property, data }),
		),
	);

	return buckets;
};
